import { giphyDarkCharcoal } from '@giphy/colors'
import { useContext, useState } from 'react'
import { IconButton, TextInput } from 'ui'
import { CopilotApiContext } from '../contexts/api'

type Props = {
    className?: string
}

const CopilotSidebarImport = ({ className }: Props) => {
    const { importPresetsById } = useContext(CopilotApiContext)
    const [value, setValue] = useState<string>('')

    function onImport() {
        if (!value) return

        importPresetsById([value])
        setValue('')
    }

    return (
        <TextInput
            className={className}
            color={giphyDarkCharcoal}
            placeholder="Enter Preset ID"
            selectOnFocus
            size="medium"
            value={value}
            onChange={setValue}
            onEnterKeyPress={() => onImport()}
        >
            <IconButton
                disabled={!value}
                gradient="purple-indigo"
                icon="add"
                size="medium"
                onClick={() => onImport()}
            />
        </TextInput>
    )
}

export default CopilotSidebarImport
